import { Token, WidgetTable_Cell } from 'emerald-ui';
import { font } from 'emerald-ui/dist/globals/fonts';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { accent2 } from 'emerald-ui/dist/globals/colors';

export const TravelHistory_Root = styled.div`
    /* stylelint-disable */
    ${WidgetTable_Cell}:first-of-type {
        font-family: ${font.medium};
        ${Token} {
            font-size: inherit;
            margin-right: .75em;
        }
    }
    /* stylelint-enable */

    ${theme.breakpoints.only('xs')} {
        ${WidgetTable_Cell} {
            font-size: .75rem; /* 12px */
        }
    }
`;

export const TravelHistory_Icon = styled.img.attrs(() => ({
    alt: '',
    role: 'presentation',
}))`
    height: 2.5em;
    width: 2.5em;
    margin-right: .5em;
`;

export const TravelHistory_Count = styled.div`
    height: 1.6em;
    width: 1.5em;
    background-color: ${accent2};
    border-radius: 2em;
    text-align: center;
    font-size: x-small;
    position: absolute;
    margin-left: 44px;
    margin-top: 28px;
    border: 1px solid white;
`;
